(function () {
    'use strict';

    angular.module("imApp").factory("shopFloorSelectOhService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3811,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
